{
  "home": {
    "title": "Your game space",
    "welcome": "Hi, {{name}}.",
    "intro": "Your daily rewards and goals, all in one place.",
    "harvest": "View the harvest and leaderboard",
    "play": {
      "title": "Your next discovery",
      "choose": "Choose my booster",
      "available_one": "{{count}} free booster available",
      "available_other": "{{count}} free boosters available",
      "next": "Next free booster in {{time}}",
      "empty": "Your free reserve is recharging.",
      "unavailable": "Reserve unavailable. Open the boosters page to try again."
    },
    "bannerAlt": "Anima Harvest: open your boosters all month, the jackpot is shared at the end of the month",
    "lastDraw": "{{name}}, {{rarity}}",
    "stats": {
      "title": "The ANIDEX world",
      "unavailable": "World statistics are temporarily unavailable.",
      "onlinePlayers": "Online",
      "registeredPlayers": "Players",
      "cardsInCirculation": "Cards",
      "animesInCirculation": "Works",
      "mythicCardsInCirculation": "Mythic",
      "divineCardsInCirculation": "Divine"
    },
    "login": {
      "combo": "{{count}} days in a row",
      "unavailable": "Calendar unavailable. Try again from its page.",
      "title": "Today’s login",
      "ready": "Reward ready",
      "streak": "Streak {{streak}} · new day in {{time}}",
      "waiting": "Your daily reward is waiting on the calendar.",
      "month": "Month {{month}}: +{{chance}}% chance next month if the streak holds.",
      "open": "Open the calendar"
    },
    "quests": {
      "progress": "View your progress",
      "unavailable": "Achievements unavailable. Try again from their page.",
      "title": "Today’s quests",
      "claimable_one": "{{count}} to claim",
      "claimable_other": "{{count}} to claim",
      "resets": "New ones in {{time}}",
      "weeklyTitle": "This week’s quests",
      "monthlyTitle": "This month’s quests",
      "ends": "Ends in {{time}}",
      "achievements": "Achievements"
    },
    "collection": {
      "title": "Your collection",
      "open": "Open the binder",
      "characters_one": "{{formatted}} character",
      "characters_other": "{{formatted}} characters",
      "fragments_one": "{{formatted}} fragment in reserve",
      "fragments_other": "{{formatted}} fragments in reserve",
      "animes_one": "{{formatted}} work completed.",
      "animes_other": "{{formatted}} works completed."
    },
    "pity": {
      "orBetter": "{{rarity}} or better",
      "next": "guaranteed on the next opening",
      "within_one": "guaranteed within {{count}} opening",
      "within_other": "guaranteed within {{count}} openings",
      "of": "of the {{name}}."
    }
  },
  "landing": {
    "start": "Start my collection",
    "free": "Free to play. Anima is an in-game currency.",
    "nextDraw": "Every booster opens a new story.",
    "experience": "Your ANIDEX experience",
    "album": "A living album, from anime to video games.",
    "community": "Meet players, trade cards and make discoveries.",
    "invite": "The first page of your album is waiting.",
    "title": "Your characters. Your story.",
    "intro": "An album for your favorite characters. Open boosters, evolve your cards and complete the works you love.",
    "seeRules": "See the rules",
    "raritiesTitle": "Seven rarities, set by popularity",
    "howTitle": "How it works",
    "openTitle": "Open boosters",
    "openText": "Spend your Anima to reveal characters. Guarantees prevent long streaks without a {{rare}}.",
    "duplicatesTitle": "Transform your duplicates",
    "duplicatesText": "Each duplicate becomes fragments for that character, from 5 for a {{common}} to 200 for a {{divine}}.",
    "upgradeTitle": "Upgrade your cards",
    "upgradeText": "Fragments unlock reflections, frames, and animations, up to the awakened look."
  },
  "auth": {
    "createAccount": "Create an account",
    "password": "Password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "login": {
      "title": "Sign in",
      "intro": "Get back to your collection and today’s quests.",
      "noAccount": "No account yet?",
      "identifier": "Email or username",
      "pending": "Signing in…"
    },
    "register": {
      "intro": "Your adventure starts with {{anima}} Anima to open your first boosters.",
      "haveAccount": "Already have an account?",
      "email": "Email address",
      "username": "Username",
      "usernameHint": "Visible to other players. Letters, digits, dot, hyphen, underscore.",
      "passwordHint_one": "{{count}} character minimum, with at least one digit or symbol.",
      "passwordHint_other": "{{count}} characters minimum, with at least one digit or symbol.",
      "terms": "I accept the <terms>terms of use</terms>. The <privacy>privacy policy</privacy> describes the account data.",
      "pending": "Creating…",
      "submit": "Create my account",
      "referralCode": "Referral code (optional)",
      "referralHint": "Your bonus of {{anima}} Anima and {{boosters}} Premium boosters arrives once your email is verified."
    }
  },
  "verify": {
    "title": "Email verification",
    "missing": "Incomplete link: open the link from your email.",
    "pending": "Verifying",
    "success": "Email confirmed. Your boosters are waiting.",
    "home": "Go to the home page",
    "referralSuccess": "Referral bonus received: {{anima}} Anima and {{boosters}} Premium boosters!"
  },
  "public": {
    "copyLink": "Copy link",
    "anime": {
      "manga": "Manga",
      "anime": "Anime",
      "novel": "Novel",
      "videoGame": "Video game",
      "cinematography": "Cinematography",
      "work": "Work",
      "lead_one": "{{type}} rank {{rank}} - {{formatted}} character to collect on ANIDEX.",
      "lead_other": "{{type}} rank {{rank}} - {{formatted}} characters to collect on ANIDEX.",
      "leadYear_one": "{{type}} rank {{rank}}, {{year}} - {{formatted}} character to collect on ANIDEX.",
      "leadYear_other": "{{type}} rank {{rank}}, {{year}} - {{formatted}} characters to collect on ANIDEX.",
      "englishTitle": "English title",
      "nativeTitle": "Native title",
      "favourites": "Favorites",
      "characters": "Characters",
      "format": "Format",
      "featured": "Featured characters",
      "open": "Open the series",
      "collect": "Collect this series"
    },
    "character": {
      "lead": "{{rarity}} card on ANIDEX.",
      "leadSeries": "{{rarity}} card from {{title}} on ANIDEX.",
      "nativeName": "Native name",
      "rarity": "Rarity",
      "favourites": "AniList favorites",
      "value": "Reference value",
      "role": "Role",
      "series": "Series",
      "view": "View in my collection",
      "collect": "Collect this character"
    }
  },
  "rules": {
    "title": "Game rules",
    "intro": "Every value below comes from the server and applies as is. Each new player receives",
    "index": "Rules sections",
    "andUp": "{{formatted}} and up",
    "nav": {
      "boosters": "Boosters",
      "pity": "Pity",
      "rarity": "Rarities",
      "upgrade": "Upgrades",
      "rank": "Ranks",
      "level": "Levels",
      "market": "Market"
    },
    "boosters": {
      "title": "Boosters and odds",
      "duplicate": "Each card has a {{percent}}% chance to turn into a character of the same rarity you already own. If you don’t own any, you keep the card you pulled.",
      "rates": "{{name}} rates",
      "free_one": "A reserve of {{count}} booster at level 1 (+{{perLevel}} per level). One booster regenerates every {{minutes}} min at level 1, for a full recharge in 1 hour.",
      "free_other": "A reserve of {{count}} boosters at level 1 (+{{perLevel}} per level). One booster regenerates every {{minutes}} min at level 1, for a full recharge in 1 hour."
    },
    "pity": {
      "title": "Pity system",
      "rule_one": "After {{count}} opening without {{rarity}}, the next opening is guaranteed {{rarity}} or better.",
      "rule_other": "After {{count}} openings without {{rarity}}, the next opening is guaranteed {{rarity}} or better.",
      "note": "The more a booster costs, the sooner its guarantee arrives. The free booster waits half again as long as the Standard. Counters stay on the server, separate for each booster type."
    },
    "rarity": {
      "title": "Rarities and fragments",
      "caption": "Rarity depends on how many favorites the character has.",
      "rarity": "Rarity",
      "favourites": "Favorites",
      "fragments": "Fragments per duplicate"
    },
    "upgrades": {
      "title": "Card upgrades",
      "hint": "10 levels, a customization at each milestone and cumulative FX. Card stats and value increase without changing drop chances.",
      "valueHint": "Value doubles through level 5 (×16), then adds 4 times the base value per level, reaching ×36 at level 10.",
      "ownershipHint": "Existing levels and fragments are preserved. Tags remain available at every level. Personal style does not transfer with a sale or trade.",
      "fromStart": "As soon as you obtain it",
      "cost_one": "{{formatted}} fragment in total",
      "cost_other": "{{formatted}} fragments in total"
    },
    "ranks": {
      "title": "Work ranks",
      "hint": "Rank is the average of the 15% most favorited characters and the 15% least favorited: each group is averaged, those two averages are added, then divided by two."
    },
    "levels": {
      "title": "Levels",
      "body": "Opening boosters and completing quests awards EXP. Each level costs more than the previous one: going from level N to N + 1 requires {{base}} × N + {{quadratic}} × N × (N − 1) EXP (level 10 → 11: {{level10}} EXP, level 100 → 101: {{level100}} EXP). Each level reached awards"
    },
    "market": {
      "title": "Market, auctions, and trades",
      "access": "Available from level {{level}}.",
      "fee": "Sale fee: {{percent}}% (rounded up), taken from the Anima and paid into the monthly Anima Harvest jackpot. Minimum price",
      "freeAdds": "Each free booster opened adds",
      "paidAdds": "to this jackpot. A paid booster adds {{percent}}% of its price (rounded up).",
      "buyback": "System buyback: {{percent}}% of the card’s value, including its level. You don’t set the price. {{pot}}% of that amount (rounded down) goes into the jackpot, the rest is paid to you, and the card leaves your collection. Several cards, or a whole rarity, sell together from Purge. Favorites stay.",
      "locked": "A card on sale, in an auction, or in a trade is locked: it can’t be upgraded or offered elsewhere.",
      "transfer": "On a transfer, your remaining fragments are set aside and returned if you get the character back. A duplicate you receive becomes fragments.",
      "listings_one": "Listings: up to {{count}} active listing, lasting {{days}}.",
      "listings_other": "Listings: up to {{count}} active listings, lasting {{days}}.",
      "days_one": "{{count}} day",
      "days_other": "{{count}} days",
      "auctions": "Auctions: durations {{hours}} h, anti-snipe {{minutes}} min.",
      "tradesBefore_one": "Trades: {{count}} card per side, up to",
      "tradesBefore_other": "Trades: {{count}} cards per side, up to",
      "tradesAfter": "from one side only. You choose who can offer you a trade (public, friends, private).",
      "abuse": "Abuse (extreme prices, repeated trades, linked accounts) can be flagged automatically. Contest a freeze through support or a report from your history."
    }
  }
}
